import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var SunFilledSvg = function SunFilledSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.09 4.976V2.25h1.82v2.727zM6.358 7.892 4.54 6.074l1.286-1.286 1.818 1.818zm11.098 4.357a5.454 5.454 0 1 1-10.91 0 5.454 5.454 0 0 1 10.91 0m.188-4.357 1.818-1.818-1.285-1.286-1.819 1.818zm0 8.714 1.818 1.818-1.285 1.286-1.819-1.818zm-11.286 0L4.54 18.424l1.286 1.286 1.818-1.818zm4.734 2.916v2.727h1.818v-2.727zm-6.364-6.364H2V11.34h2.727zm14.546 0H22V11.34h-2.727z",
    clipRule: "evenodd"
  }));
};
export var SunFilled = function SunFilled(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: SunFilledSvg
  }));
};